import * as types from "../../_constants/types";

export default (state = { loading: false }, action) => {
    switch (action.type) {
        case types.INVOICE_FETCHING:
            return { loading: true };

        case types.INVOICE_FETCHING_COMPLETED:
            return { loading: false };

        case types.INVOICE_FETCHING_FAILED:
            return { loading: false, err: action.type };

        default:
            return state;
    }
};
